var _circle, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBigQueryImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 170,
    height: 170,
    viewBox: "0 0 170 170",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 85,
    cy: 85,
    r: 81,
    fill: "white",
    stroke: "#233C85",
    strokeWidth: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.041 82.125V93.0833C67.7683 96.0609 70.2189 98.5546 73.166 100.333V82.125H66.041Z",
    fill: "#AECBFA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.208 72.0391V103.414C80.7415 103.61 82.2873 103.693 83.833 103.664C85.2205 103.751 86.6121 103.751 87.9997 103.664V72.0391H79.208Z",
    fill: "#669DF6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.833 86.4141V100.122C97.7959 98.2325 100.233 95.6238 101.916 92.5391V86.4141H94.833Z",
    fill: "#AECBFA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M111.917 104.998L106 110.915C105.834 111.078 105.701 111.272 105.611 111.487C105.521 111.701 105.475 111.932 105.475 112.165C105.475 112.397 105.521 112.628 105.611 112.843C105.701 113.057 105.834 113.252 106 113.415L120.75 128.165C121.077 128.488 121.519 128.669 121.979 128.669C122.439 128.669 122.881 128.488 123.208 128.165L129.167 122.206C129.49 121.879 129.671 121.437 129.671 120.977C129.671 120.517 129.49 120.075 129.167 119.748L114.417 104.998C114.254 104.832 114.059 104.699 113.844 104.609C113.63 104.519 113.399 104.473 113.167 104.473C112.934 104.473 112.703 104.519 112.489 104.609C112.274 104.699 112.079 104.832 111.917 104.998Z",
    fill: "#4285F4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.833 45.332C76.4162 45.332 69.166 47.5314 62.9991 51.6519C56.8323 55.7725 52.0258 61.6292 49.1875 68.4814C46.3493 75.3336 45.6066 82.8736 47.0536 90.1479C48.5005 97.4222 52.0721 104.104 57.3165 109.349C62.561 114.593 69.2429 118.165 76.5171 119.611C83.7914 121.058 91.3314 120.316 98.1837 117.478C105.036 114.639 110.893 109.833 115.013 103.666C119.134 97.4991 121.333 90.2488 121.333 82.832C121.333 77.9075 120.363 73.0311 118.479 68.4814C116.594 63.9317 113.832 59.7977 110.35 56.3155C106.867 52.8333 102.733 50.0711 98.1837 48.1865C93.6339 46.302 88.7576 45.332 83.833 45.332ZM83.833 110.707C78.3317 110.699 72.9561 109.06 68.3854 105.999C63.8146 102.937 60.2536 98.59 58.1521 93.5058C56.0506 88.4216 55.503 82.8287 56.5782 77.4335C57.6535 72.0382 60.3035 67.0826 64.1936 63.1926C68.0836 59.3025 73.0392 56.6525 78.4345 55.5772C83.8297 54.502 89.4226 55.0496 94.5068 57.1511C99.591 59.2526 103.938 62.8136 107 67.3844C110.061 71.9551 111.7 77.3307 111.708 82.832C111.714 86.4942 110.996 90.1214 109.597 93.5058C108.198 96.8902 106.145 99.9653 103.556 102.555C100.966 105.144 97.8912 107.197 94.5068 108.596C91.1224 109.995 87.4952 110.713 83.833 110.707Z",
    fill: "#669DF6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBigQueryImg);
export default __webpack_public_path__ + "static/media/BigQueryImg.636ae480039f2d35907a35fa7411f14f.svg";
export { ForwardRef as ReactComponent };